/**
 * Test kayıtları: ana adminin sistemi denemek için eklediği kullanıcılar,
 * projeler ve merkezler. Raporlarda yalnızca ana admin görür; kayıtlar silinmez,
 * diğer kullanıcılar için ekrana gelmeden önce ayıklanır.
 */

const MAIN_ADMIN_EMAIL = 'turanemre1999@gmail.com';
const TEST_EMPLOYEE_EMAILS = [MAIN_ADMIN_EMAIL, 'orhan.er@bakircay.edu.tr'];

// Merkezlerde test işareti yok ve gerçek merkez adlarında da "deneme" geçebilir,
// bu yüzden eşleşme ada göre değil kimliğe göre. Yeni test merkezi buraya eklenir.
const TEST_CENTER_IDS = [
  'tvxweYB7WKbi7uaEmzY6', // Deneme Merkezi
];

const normalizeEmail = (email) => String(email || '').trim().toLowerCase();
const isTestCenter = (centerId) => TEST_CENTER_IDS.includes(centerId);

// isTestProject bazı kayıtlarda 'true' metni olarak saklanıyor
export const isTestProject = (project) => project?.isTestProject === true || project?.isTestProject === 'true';

/** Verilen Projects belgelerinden test projelerinin kimlikleri. */
export const getTestProjectIds = (projectDocs) => new Set(
  projectDocs.filter((projectDoc) => isTestProject(projectDoc.data())).map((projectDoc) => projectDoc.id)
);

/**
 * Görüntüleyene göre test kayıtlarını ayıklayan süzgeçler. Ana adminde her
 * süzgeç listeyi olduğu gibi döndürür; e-posta bilinmiyorsa kayıtlar gizli kalır.
 *
 *  - projectDocs / centerDocs: Projects ve Centers belgeleri
 *  - people: `email` alanı taşıyan kişi listeleri (çalışan, SMO, bölge müdürü)
 *  - records: Visits ve CalendarJobs kayıtları (test projesi ya da test merkezi)
 *  - hidesCenter: tek bir merkez kimliği için aynı karar
 */
export const createTestDataFilters = (viewerEmail) => {
  const showAll = normalizeEmail(viewerEmail) === MAIN_ADMIN_EMAIL;
  const without = (list, isTest) => (showAll ? list : list.filter((item) => !isTest(item)));
  return {
    projectDocs: (docs) => without(docs, (projectDoc) => isTestProject(projectDoc.data())),
    centerDocs: (docs) => without(docs, (centerDoc) => isTestCenter(centerDoc.id)),
    people: (list) => without(list, (person) => TEST_EMPLOYEE_EMAILS.includes(normalizeEmail(person.email))),
    records: (list, testProjectIds) => without(list, (record) => testProjectIds.has(record.projectId) || isTestCenter(record.hospital)),
    hidesCenter: (centerId) => !showAll && isTestCenter(centerId),
  };
};
